import React from 'react'

function style2() {
    return (
           <svg xmlns="http://www.w3.org/2000/svg" width="86" height="41" viewBox="0 0 86 41">
           <defs>
           </defs>
           <g transform="translate(-106 -633)">
           <g className="a" fill="#fff" stroke="none" strokeMiterlimit="10" transform="translate(106 633)">
           <rect className="e" stroke="none" width="86" height="41" rx="2"/>
           <rect className="f" x="0.5" y="0.5" width="85" height="40" rx="1.5"/>
           </g><g className="b" stroke="#acacac" strokeWidth="0.5px" fill="none" transform="translate(116 643)">
           <rect className="e" stroke="none" width="67" height="26"/>
           <rect className="f" fill="none" x="0.25" y="0.25" width="66.5" height="25.5"/>
           </g>
           <g className="c" fill="#efefef" stroke="#acacac" strokeWidth="0.5px" transform="translate(116 638)">
           <rect className="e" stroke="none" width="67" height="7"/>
           <rect className="f" fill="none" x="0.25" y="0.25" width="66.5" height="6.5"/>
           </g>
           <rect className="d" fill="#0072c6" width="4" height="7" transform="translate(116 638)"/>
           </g>
           </svg>
    )
}

export default style2
